import { SvgIconProps } from '@material-ui/core';
import React from 'react';

const RejectEnrollmentIcon = (props: SvgIconProps): JSX.Element => (
  <svg
    fill="none"
    height="39"
    viewBox="0 0 43 42"
    width="40"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M27.7956 4.34945V31.145L21.0967 27.7956L14.3978 31.145L7.6989 27.7956L1 31.145V4.34945C1 3.46112 1.35289 2.60917 1.98103 1.98103C2.60917 1.35289 3.46112 1 4.34945 1H24.4461C25.3345 1 26.1864 1.35289 26.8146 1.98103C27.4427 2.60917 27.7956 3.46112 27.7956 4.34945Z"
      stroke="#EB5757"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.66567"
    />
    <path
      d="M22.1562 15.1387C22.6133 15.1387 23 15.5254 23 15.9824C23 18.9355 20.5742 21.3262 17.6562 21.3262H10.0977L12.3125 23.5762C12.6641 23.8926 12.6641 24.4199 12.3125 24.7363C12.1719 24.9121 11.9609 24.9824 11.75 24.9824C11.5039 24.9824 11.293 24.9121 11.1172 24.7363L7.46094 21.0801C7.14453 20.7637 7.14453 20.2363 7.46094 19.9199L11.1172 16.2637C11.4688 15.9121 11.9961 15.9121 12.3125 16.2637C12.6641 16.5801 12.6641 17.1074 12.3125 17.4238L10.0977 19.6387H17.6562C19.6602 19.6387 21.3125 18.0215 21.3125 15.9824C21.3125 15.5254 21.6641 15.1387 22.1562 15.1387ZM10.3438 12.3262C8.30469 12.3262 6.6875 13.9785 6.6875 15.9824C6.6875 16.4746 6.30078 16.8262 5.84375 16.8262C5.35156 16.8262 5 16.4746 5 15.9824C5 13.0645 7.39062 10.6387 10.3438 10.6387H17.8672L15.6523 8.42383C15.3008 8.10742 15.3008 7.58008 15.6523 7.26367C15.9688 6.91211 16.4961 6.91211 16.8125 7.26367L20.4688 10.9199C20.8203 11.2363 20.8203 11.7637 20.4688 12.0801L16.8125 15.7363C16.6719 15.9121 16.4609 15.9824 16.25 15.9824C16.0039 15.9824 15.793 15.9121 15.6523 15.7363C15.3008 15.4199 15.3008 14.8926 15.6523 14.5762L17.8672 12.3262H10.3438Z"
      fill="#EB5757"
    />
    <circle
      cx="31.4228"
      cy="30.2055"
      fill="#EB5757"
      r="10.4121"
      stroke="white"
      strokeWidth="1.67"
    />
    <path
      d="M36.1501 25.8655C36.1501 25.748 36.0568 25.6519 35.9429 25.6519L34.2335 25.6599L31.659 28.8239L29.0872 25.6625L27.3752 25.6545C27.2612 25.6545 27.168 25.748 27.168 25.8681C27.168 25.9189 27.1861 25.9669 27.2172 26.007L30.5868 30.1456L27.2172 34.2815C27.1859 34.3206 27.1685 34.3696 27.168 34.4203C27.168 34.5378 27.2612 34.634 27.3752 34.634L29.0872 34.6259L31.659 31.4619L34.2309 34.6233L35.9403 34.6313C36.0542 34.6313 36.1475 34.5378 36.1475 34.4177C36.1475 34.3669 36.1293 34.3189 36.0983 34.2788L32.7339 30.1429L36.1034 26.0043C36.1345 25.9669 36.1501 25.9162 36.1501 25.8655Z"
      fill="white"
    />
  </svg>
);

export default RejectEnrollmentIcon;
